import classNames from 'classnames'

import { Button, BUTTON_SIZE, BUTTON_TYPES } from '../button'

import styles from './productCTA.module.scss'
interface DisplayButtonType {
  onClick: () => void
  className?: string
  showLoader?: boolean
  selectorKey?: string
  children?: string
  buttonRef?: any
  disabled?: boolean
  buttonType?: BUTTON_TYPES
  showNewPdpUI?: boolean
}
export const ProductDisplayButton = ({
  children,
  onClick,
  className,
  showLoader,
  selectorKey,
  buttonRef,
  disabled = false,
  buttonType = BUTTON_TYPES.PRIMARY,
  showNewPdpUI = false,
}: DisplayButtonType) => {
  return (
    <Button
      className={classNames(
        styles.displayButtonWrapper,
        className,
        disabled && styles.productCTADisabled,
        showNewPdpUI && styles.displayButtonWrapper_adjustedPadding,
      )}
      type={buttonType}
      size={BUTTON_SIZE.LARGE}
      disabled={disabled}
      round={true}
      onClick={onClick}
      showLoader={showLoader}
      selectorKey={selectorKey}
      buttonRef={buttonRef}
    >
      {children}
    </Button>
  )
}
